// extracted by mini-css-extract-plugin
export default {"contactContainer":"Contact_contactContainer__K3Adi","childContainer":"Contact_childContainer__cS5Ob","backButton":"Contact_backButton__8Jk-6"};